import api from '@/apis/di/bankInfoAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('bankInfo', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_bank_info',
    field: {
      key: 'bank_info_id',
      code: 'bank_account',
      name: 'bank_name',
      quickFollow: 'inactive', // TPNam-2022/05/09 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  DataFilter() {
    return state.items.filter(x => x.open_in_budget == 1);
  },
};
const mutations = {
  ...crud.mutations,
};
export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
